import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostDetails } from '../../redux/post/postSlice';
import { Container, Box, Typography } from "@mui/material";
import PostHeader from '../../components/postDetails/PostHeader/PostHeader';
import GalleryViewer from '../../components/postDetails/GalleryViewer/GalleryViewer';
import AmenitiesGrid from '../../components/postDetails/AmenitiesGrid/AmenitiesGrid';
import ContactCard from '../../components/postDetails/ContactCard/ContactCard';
import BehaviorSection from '../../components/postDetails/BehaviorSection/BehaviorSection';
import DetailsSection from '../../components/postDetails/DetailsSection/DetailsSection';
import PostDetailsPageSkeleton from './PostDetailsPageSkeleton';

const PostDetailsPage = () => {
  const { postId } = useParams();
  const dispatch = useDispatch();
  const { post, status } = useSelector((state) => state.post);
  useEffect(() => {
    dispatch(fetchPostDetails(postId));
  }, [dispatch, postId]);

  if (status === 'loading') return <PostDetailsPageSkeleton />;
  if (!post) return <div>Post not found</div>;

  const sectionCardSx = {
    borderRadius: "4px",
    backgroundColor: "#001d3d",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    border: "1px solid rgba(255,255,255,0.12)",
    p: 3,
    mb: 4,
  };

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh" }}>
      <Container maxWidth={false} sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box>
          <PostHeader post={post} />
          <GalleryViewer images={post.postImages} />

          <Box sx={{ ...sectionCardSx }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3, color: "#fff", fontSize: "1.1rem" }}>
              About this space
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7, color: "rgba(255,255,255,0.85)", fontSize: "0.9rem" }}>
              {post.description || "No description provided."}
            </Typography>
          </Box>

          <DetailsSection post={post} />
          <BehaviorSection expected={post.expectedBehaviours} unacceptable={post.unacceptableBehaviours} />

          <Box sx={{ ...sectionCardSx, mt: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3, color: "#fff", fontSize: "1.1rem" }}>
              Amenities
            </Typography>
            <AmenitiesGrid amenities={post.amenities} />
          </Box>

          <Box sx={{ mt: 4 }}>
            <ContactCard
              phone={post.contactInfo}
              email={post.author?.email}
              social={post.postOwnerInfo?.socialMediaHandles}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PostDetailsPage;